// @ts-strict-ignore
export const lineOptions = (points) => ({
  responsive: true,
  maintainAspectRatio: true,
  redraw: true,
  elements: {
    point: {
      backgroundColor: '#DB4D75',
      radius: (ctx: any) => (points.includes(ctx.parsed?.x) ? 8 : 3),
    },
  },
  aspectRatio: 2,
  scales: {
    y: {
      position: 'right',
      color: '#ADAFB3',
      ticks: {
        callback: (val: number) => (val % 1000 === 0 ? `£${val / 1000}K` : `£${val}`),
      },
      grid: {
        borderColor: '#ADAFB3',
      },
    },
    x: {
      grid: {
        borderColor: '#ADAFB3',
      },
      ticks: {
        maxRotation: 20,
        autoSkip: true,
        includeBounds: true,
      },
    },
  },
  plugins: {
    legend: {
      onClick: () => {},
      position: 'bottom' as const,
      display: true,
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
        font: {
          size: 14,
        },
      },
    },
  },
})
